import React, { FunctionComponent } from 'react';
import { authSelectors } from '../../../../../app/auth/auth.selectors';
import { userSelectors } from '../../../../../app/resource/user/user.selectors';
import { convertAndFormatDateToUserTimeZone } from '../../../../../utils/date.utils';
import { useSelect, useSelectWithParams } from '../../../../../utils/selector.utils';
import { IChartSidebarItemProps } from './types';

function getAuthorName(firstName?: string, lastName?: string): string | null {
  const name = `${firstName ?? ''} ${lastName ?? ''}`.trim();
  return name || null;
}

const sidebarButtonStyle: React.CSSProperties = {
  height: 'auto',
  minHeight: 40,
  whiteSpace: 'normal',
  alignItems: 'flex-start',
};

export const ChartSidebarItem: FunctionComponent<IChartSidebarItemProps> = ({
  title,
  chart,
  isSelected,
  onClick,
  buttonTitle,
  showDateInSubtitle = false,
  className = 'btn darkGray w100 mb-1 mx-0 px-1',
  style,
}) => {
  const loggedUserId = useSelect(authSelectors.selectLoggedUser);
  const loggedUser = useSelectWithParams(userSelectors.selectResourceById, loggedUserId ?? '');
  const user = useSelectWithParams(userSelectors.selectResourceById, chart.changedBy ?? '');
  const authorName = user ? getAuthorName(user.firstName, user.lastName) : null;
  const chartDate = chart.updatedAt ?? chart.createdAt;
  const formattedDate =
    showDateInSubtitle && chartDate
      ? loggedUser?.timezone
        ? convertAndFormatDateToUserTimeZone(chartDate, loggedUser.timezone, 'MM/DD/YYYY h:mm A')
        : null
      : null;
  const subtitleParts = [formattedDate, authorName].filter(Boolean);
  const subtitle = subtitleParts.length > 0 ? subtitleParts.join(' · ') : null;

  return (
    <button
      type="button"
      className={`${className}${isSelected ? ' active' : ''}`}
      title={buttonTitle}
      onClick={onClick}
      style={{ ...sidebarButtonStyle, ...style }}
    >
      <span className="flex flex-column" style={{ alignItems: 'flex-start', textAlign: 'left', width: '100%' }}>
        <span>{title}</span>
        {subtitle ? (
          <span className="f-0" style={{ fontWeight: 'normal', marginTop: 2 }}>
            {subtitle}
          </span>
        ) : null}
      </span>
    </button>
  );
};
